// `date.toISOString().slice(0, 10)` normalizes to UTC first, so for anyone
// east of UTC (e.g. Europe/Helsinki) it silently returns YESTERDAY's date
// during the early hours of the day (until UTC catches up to local midnight).
// A Game Plan created or a "today" cutoff computed during that window would
// land on the wrong calendar day — this is what the backend's own
// _user_today() comment calls "the UTC midnight bug". Use these instead of
// toISOString() whenever the date must match the athlete's own calendar day.
export function toLocalISO(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function todayLocal() {
  return toLocalISO(new Date());
}

// ── Display-locale formatting ───────────────────────────────────────────────
// The user's chosen locale (user_profiles.locale, from onboarding/profile
// settings — see countryData.js). Module-level like browserTimezone()'s
// counterpart, set once App.js loads the profile; everything in the app
// that formats a date for display reads it from here instead of
// hardcoding 'en-GB' or relying on the browser's own guess, so a UK, US,
// Australian or Finnish athlete each see their own convention consistently.
let _locale = null;

export function setDisplayLocale(locale) {
  _locale = locale || null;
}

export function getDisplayLocale() {
  if (_locale) return _locale;
  try { return navigator.language || 'en-GB'; } catch (e) { return 'en-GB'; }
}

// Formats an ISO date string ("2026-10-20") in the user's locale. Defaults
// to day + short month (+ year when asked), the shape almost every date in
// this app needs; pass `opts` to override.
export function formatDate(iso, opts) {
  if (!iso) return '—';
  const d = new Date(iso.slice(0, 10) + 'T12:00:00');
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(getDisplayLocale(), opts || { day: 'numeric', month: 'short' });
}

export function formatDateLong(iso, opts) {
  if (!iso) return '—';
  const d = new Date(iso.slice(0, 10) + 'T12:00:00');
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(getDisplayLocale(), opts || { day: 'numeric', month: 'short', year: 'numeric' });
}
